import React from 'react';

const UploadBoxWrapper = ({ children, size, shape = 'square', cursor = true, variant = 'preview' }) => {
	const hoverStyles = `
    /* Container styles */
    .upload-container {
      width: 100%;
      height: ${size ? `${size}px` : '100%'};
      display: flex;
      justify-content: center;
    }
    
    /* Wrapper styles */
    .upload-wrapper {
      width: 100%;
      height: ${size ? `${size}px` : '100%'};
      border-radius: ${shape === 'circle' ? '50%' : '8px'};
      overflow: hidden;
      position: relative;
      cursor: ${cursor ? 'pointer' : 'default'};
      border: 1px dashed #d9d9d9;
      background-color: ${variant === 'upload' ? '#fff' : 'transparent'};
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .upload-wrapper:hover {
      border-color: #1890ff;
    }
    
    /* Upload placeholder styles */
    .uploadPlaceholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #8c8c8c;
      font-size: 16px;
      gap: 10px;
      width: 100%;
      height: 100%;
      padding: 24px;
      text-align: center;
    }
    
    .uploadIcon {
      font-size: 24px;
    }
    
    /* Content container styles */
    .contentContainer {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    
    /* Edit icon container styles */
    .editIconContainer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 1;
    }
    
    .upload-wrapper:hover .editIconContainer {
      opacity: 1;
    }
    
    .editIconContent {
      color: white;
      font-size: 16px;
      text-align: center;
      margin: 0;
    }
    
    /* Image and avatar styles */
    .imageLazy {
      width: 100%;
      height: ${size ? `${size}px` : '100%'};
      object-fit: cover;
    }
    
    .avatarFill {
      width: 100% !important;
      height: 100% !important;
      font-size: 48px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `;

	return (
		<>
			<style>{hoverStyles}</style>
			<div>{children}</div>
		</>
	);
};

export default UploadBoxWrapper;
